import { text } from '@fortawesome/fontawesome-svg-core'
import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    commentListItem: {
      padding: '0px 20px',
      margin: 20
    },
    userItem: {
      marginBottom: 10,
      textAlign: 'left',
      fontWeight: 'bold'
    },
    descriptionItem: {
      textAlign: 'left',
      marginBottom: 20
    },
    dateItem: {
      textAlign: 'left',
      color: 'gray',
      marginBottom: 20
    }
  })
